import { render, staticRenderFns } from "./CustomerContactTypeEdit.vue?vue&type=template&id=f60a60f6&"
import script from "./CustomerContactTypeEdit.vue?vue&type=script&lang=js&"
export * from "./CustomerContactTypeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports